import { getNestedProperty } from '@opallabs/lambda'
import { ContentCollection, State, StateKeys } from '../../../../types'

type GetContent = (state: State) => ContentCollection | undefined

export const getContent: GetContent = (state) =>
  getNestedProperty<ContentCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.content
  )
